module.exports = __webpack_public_path__ + "static/drone_delivery-f6f58df08587385e7b8727af1078e151.svg";